<template>
  <div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      @click="toggleDialogVisible(true)"
    >
      添加任务
    </el-button>
    <el-dialog
      title="添加任务"
      :visible.sync="dialogVisible"
      @close="closeDialog"
      width="700px"
    >
      <el-form :model="form" ref="form" label-width="200px">
        <el-form-item
          label="分红时间："
          prop="dividendTime"
          :rules="[{ required: true, message: '分红时间不能为空' }]"
        >
          <el-date-picker
            value-format="timestamp"
            v-model="form.dividendTime"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="分红类型："
          prop="type"
          :rules="[{ required: true, message: '分红类型不能为空' }]"
        >
          <el-select v-model="form.type" placeholder="请选择">
            <el-option
              v-for="item in typeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="分红金额："
          prop="amount"
          :rules="[{ required: true, message: '分红金额不能为空' }]"
        >
          <el-input type="text" v-model="form.amount"></el-input>
        </el-form-item>
        <el-form-item
          label="分红币种："
          prop="coinType"
          :rules="[{ required: true, message: '分红币种不能为空' }]"
        >
          <el-input type="text" v-model="form.coinType"></el-input>
        </el-form-item>
        <el-form-item
          label="扣减分红池金额(USDT)："
          prop="deductionAmount"
          :rules="[{ required: true, message: '扣减分红池金额不能为空' }]"
        >
          <el-input type="text" v-model="form.deductionAmount"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toggleDialogVisible(false)">取消</el-button>
        <el-button type="primary" @click="handleSubmit('form')">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DividendCreateTask',
  data() {
    return {
      dialogVisible: false,
      form: {
        type: 1,
        dividendTime: null,
        coinType: '',
        amount: null,
        dividendTime: null,
        deductionAmount: null
      },
      typeList: [
        { label: '初级股东分红', value: 1 },
        { label: '中级股东分红', value: 2 },
        { label: '高级股东分红', value: 3 }
      ]
    };
  },
  methods: {
    ...mapActions('dividendTask', ['create']),
    toggleDialogVisible(visible) {
      this.dialogVisible = visible;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$refs['form'].resetFields();
    },
    handleSubmit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.create(this.form).then(() => {
            this.$message.success('创建成功！');
            this.toggleDialogVisible(false);
            this.$emit('onSuccess');
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
